import React from "react";
import * as S from "./styles";
import { AccountTile } from "./AccountTile";
import { PasswordTile } from "./PasswordTile";
export var AccountTabTiles = function AccountTabTiles() {
  return React.createElement(S.Container, null, React.createElement(AccountTile, null), React.createElement(PasswordTile, null));
};